// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","BoldHeading":"BoldHeading-2vxwnsnv9ufd8fgduzseeg1dbrj38nmfjvk7t5p7zg5kt4rj4errrrdzux7pbvw63fhtw4ftczk73zcytw8pxgk7wbnnw45x4vw2jpd","RodoPolicyContent":"RodoPolicyContent-2xgz5u2fghec2qwkgprnthj46482bgsczxd38pjpkxrfweqvdpzdfqjq7gp344buk6a83bza9qxc2brv8fxbr5ee8djr5e253m6bk3b","loading":"loading-3neqbt8z217et27z5upjhwje7yhx64qjt2mxuaapg9nybqwr1ujcx9m6eru9v4cy1nfsfpmk2xhtxbq35qywdav6x7uh8u492vhf6p","pulse":"pulse-sstt5871vaqfmytq72hkxn7sjaux7jjjeykwp6dyrgz42spm8r8fn1hjbr58t2qmm7kb75m7fbbr9cdps9d6y5tb6z5dw14q4vdh8s"};


//////////////////
// WEBPACK FOOTER
// ./src/views/RodoPolicy/RodoPolicy.module.scss
// module id = 1789
// module chunks = 0